import React from "react";
import "./OrangeFilledSquareBtn.css";
import { Button } from "react-bootstrap";

function OrangeFilledSquareBtn({ btnText, onClick }) {
  return (
    <section className="OrangeFilledSquareBtn">
      <Button className="Orange_Btn" onClick={onClick}>{btnText}</Button>
    </section>
  );
}

export default OrangeFilledSquareBtn;
